import get from "lodash/get";

import React, { useEffect, useState } from "react";
import Navigation from "./navigation";
import Content from "./sections/content";
import Buttons from "./sections/semantic/buttons";
import Dates from "./sections/components/dates";
import Dropdowns from "./sections/components/dropdowns";
import Modals from "./sections/components/modals";
import Colors from "./sections/semantic/colors";
import Controls from "./sections/semantic/controls";
import Inputs from "./sections/semantic/inputs";
import Tables from "./sections/semantic/tables";
import Tipography from "./sections/semantic/tipography";
import Graphs from "./sections/semantic/graphs";
import Head from "./head";
import IconsList from "./icons";
import Navs from "./sections/components/navs";
import TestModal from "./sections/components/testModal";
import { useRillContext } from "../../rill/RillReact/share/base";

function View() {
  const { locals } = useRillContext();

  const [selectedSection, setSelectedSection] = useState("tipography");
  const sectionList = {
    semantic: [
      "tipography",
      "colors",
      "buttons",
      "inputs-search",
      "controls",
      "graphs",
      "tables",
    ],
    components: ["dates", "dropdowns", "modals", "navigation", "icons"],
    start: ["Running the project", "Files Structure", "Usage", "Refactoring"],
  };
  const sections = {
    buttons: { component: <Buttons />, title: "Buttons" },
    dates: { component: <Dates />, title: "Dates" },
    dropdowns: { component: <Dropdowns />, title: "Dropdowns" },
    modals: { component: <Modals />, title: "Modals" },
    colors: { component: <Colors />, title: "Colors" },
    controls: { component: <Controls />, title: "Controls" },
    graphs: { component: <Graphs />, title: "Graphs" },
    "inputs-search": { component: <Inputs />, title: "Inputs - Search" },
    tables: { component: <Tables />, title: "Tables" },
    tipography: { component: <Tipography />, title: "Tipography" },
    icons: { component: <IconsList icons={locals.iconList} />, title: "Icons" },
    navigation: { component: <Navs />, title: "Navigation" },
  };
  return (
    <main role="docs-wrapper" class="max-w-[90%] m-auto">
      <Head title={sections[selectedSection].title} />
      <div className="flex gap-12">
        <Navigation
          sectionList={sectionList}
          selectedSection={selectedSection}
          setSelectedSection={setSelectedSection}
        />
        <Content>{sections[selectedSection]?.component || null}</Content>
      </div>
    </main>
  );
}

const Docs = async (app) => {
  app.get("/docs", async ({ req, res, locals, load }) => {
    const environment = process.env.NODE_ENV;
    if (environment !== "development" && environment !== "local") {
      res.redirect("/");
    }
    await load("iconList");
    const { query } = req;
    const modal = get(query, "modal", {});
    locals.modal = {
      "test-modal": <TestModal />,
    }[modal.type];
    res.body = <View />;
  });
};

export default Docs;
